import { userQueryKey } from '@services/user/keys';
import { useQueryClient, useMutation } from '@tanstack/react-query';
import { useClient } from '@utils/api-client';

export const useDeleteUser = () => {
  const queryClient = useQueryClient();
  const client = useClient();
  const result = useMutation({
    mutationFn: (params: { userId: string }) => {
      const { userId } = params;
      return client.delete(`user/${userId}`);
    },
    onSuccess: (res, user) => {
      queryClient.invalidateQueries({ queryKey: userQueryKey.getWithParams(user.userId) });
      queryClient.invalidateQueries({ queryKey: userQueryKey.search });
    },
  });
  return { ...result, deleteUser: result.mutateAsync };
};
